// extracted by mini-css-extract-plugin
export default {"wrapper-form":"PoaCreatForm_wrapper-form__T9ttp","wrapper-group":"PoaCreatForm_wrapper-group__1haQ6","label":"PoaCreatForm_label__qfAaB"};